import React from "react";
import { RouteObject } from "react-router-dom";

import {
  checkAnyScope,
  checkBooleanScope,
} from "@src/components/ScopeWrappers/helpers";

import { PERSONALIZATION_ROUTES } from "../../routes";

export const PersonalizationPaddedRoutes: RouteObject[] = [
  {
    path: PERSONALIZATION_ROUTES.Personalizations,
    lazy: async () => {
      const { PersonalizationOverviewRoute } = await import(
        "../../../features/personalizations/pages/personalizationOverview/PersonalizationOverview.route"
      );
      const { ScopedRoute } = await import(
        "../../../components/ScopeWrappers/ScopedRoute"
      );
      return {
        element: (
          <ScopedRoute
            isEnabled={(org) =>
              checkAnyScope([
                checkBooleanScope("personalizations", org.configurations),
              ])
            }
            debugId={PERSONALIZATION_ROUTES.Personalizations}
            children={PersonalizationOverviewRoute}
          />
        ),
      };
    },
  },
];
